<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons
      *ngIf="showSalonProfile"
      slot="start"
      style="margin-left: 1rem"
    >
      <b (click)="salonProfile()"> ← Back </b>
    </ion-buttons>
    <ion-buttons
      *ngIf="!showSalonProfile"
      slot="start"
      style="margin-left: 1rem"
    >
      <b routerLink="/login"> ← Back </b>
    </ion-buttons>
    <ion-title *ngIf="!showSalonProfile" style="text-align: center"
      >Welcome</ion-title
    >
    <ion-title *ngIf="showSalonProfile" style="text-align: center"
      >Salon Profile</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size-xl="8" size-lg="10" size-sm>
        <ion-card>
          <div class="card-content-left">
            <div
              *ngIf="!showSalonProfile"
              tappable
              class="back-button"
              routerLink="/login"
            >
              <span> ← Back </span>
            </div>
            <div
              *ngIf="showSalonProfile"
              tappable
              class="back-button"
              (click)="salonProfile()"
            >
              <span> ← Back </span>
            </div>
            <div>
              <div style="padding: 3rem; height: 500px; margin-top: 1rem">
                <div
                  style="margin: auto; margin-bottom: 2rem; max-width: 330px"
                >
                  <img src="./assets/images/welcome.png" />
                </div>
                <span *ngIf="!showSalonProfile" class="profile-label">
                  Please tell us about yourself
                </span>
                <span *ngIf="showSalonProfile" class="profile-label">
                  Please tell us about your awesome business
                </span>
              </div>
            </div>
          </div>
          <div class="card-content-right">
            <form
              [formGroup]="registerInfoForm"
              (ngSubmit)="onSalonInfoFormSave()"
            >
              <input type="hidden" formControlName="firstName" />
              <input type="hidden" formControlName="lastName" />
              <input type="hidden" formControlName="email" />
              <input type="hidden" formControlName="password" />
              <input type="hidden" formControlName="salonName" />
              <input type="hidden" formControlName="country" />
              <input type="hidden" formControlName="timeZone" />
              <div *ngIf="!showSalonProfile">
                <div class="logo-container">
                  <img src="./assets/images/login_logo_white.png" />
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">First Name*</ion-label>
                  </div>
                  <ion-input
                    type="text"
                    name="firstName"
                    placeholder="Your first name"
                    formControlName="firstName"
                    (focusout)="this.firstNameSelected = true"
                    (ionFocus)="firstNameFocus()"
                  ></ion-input>
                  <span
                    *ngIf="firstNameSelected && this.registerInfoForm.get('firstName').hasError('required')"
                    class="error"
                    >Oops, a first name is required.</span
                  >
                  <span
                    *ngIf="firstNameSelected && this.registerInfoForm.get('firstName').hasError('maxlength')"
                    class="error"
                    >A first name cannot exceed 30 letters.</span
                  >
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Last Name*</ion-label>
                  </div>
                  <ion-input
                    type="text"
                    name="lastName"
                    placeholder="Your last name"
                    formControlName="lastName"
                    (focusout)="this.lastNameSelected = true"
                    (ionFocus)="lastNameFocus()"
                  ></ion-input>
                  <span
                    *ngIf="lastNameSelected && this.registerInfoForm.get('lastName').hasError('required')"
                    class="error"
                    >Oops, a last name is required.</span
                  >
                  <span
                    *ngIf="lastNameSelected && this.registerInfoForm.get('lastName').hasError('maxlength')"
                    class="error"
                    >A last name cannot exceed 35 letters.</span
                  >
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Email*</ion-label>
                  </div>
                  <ion-input
                    type="email"
                    name="email"
                    placeholder="Your email"
                    formControlName="email"
                    (focusout)="this.emailSelected = true"
                    (ionFocus)="emailFocus()"
                  ></ion-input>
                  <ion-spinner
                    *ngIf="email.pending"
                    icon="crescent"
                    color="primary"
                  ></ion-spinner>
                  <span
                    *ngIf="emailSelected && this.registerInfoForm.get('email').hasError('required')"
                    class="error"
                    >Email is required.</span
                  >
                  <span
                    *ngIf="emailSelected && this.registerInfoForm.get('email').hasError('validateEmail')"
                    class="error"
                    >Oops, this email is invalid.</span
                  >
                  <span
                    *ngIf="emailSelected && this.registerInfoForm.get('email').hasError('maxlength')"
                    class="error"
                    >An email cannot exceed 100 letters.</span
                  >
                  <span
                    *ngIf="emailSelected && this.registerInfoForm.get('email').hasError('stylistEmailAvailability')"
                    class="error"
                    >Email already taken.</span
                  >
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Phone number*</ion-label>
                  </div>
                  <ion-input
                    type="phoneNumber"
                    name="phoneNumber"
                    placeholder="Your phone number"
                    formControlName="phoneNumber"
                    (focusout)="this.phoneNumberSelected = true"
                    (ionFocus)="phoneNumberFocus()"
                  ></ion-input>
                  <ion-spinner
                    *ngIf="phoneNumber.pending"
                    icon="crescent"
                    color="primary"
                  ></ion-spinner>
                  <span
                    *ngIf="phoneNumberSelected && this.registerInfoForm.get('phoneNumber').hasError('required')"
                    class="error"
                    >Phone number is required.</span
                  >
                  <span
                    *ngIf="phoneNumberSelected && this.registerInfoForm.get('phoneNumber').hasError('validateEmail')"
                    class="error"
                    >Oops, this phone number is invalid.</span
                  >
                  <span
                    *ngIf="phoneNumberSelected && this.registerInfoForm.get('phoneNumber').hasError('maxlength')"
                    class="error"
                    >Phone number cannot exceed 12 letters.</span
                  >
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Password*</ion-label>
                  </div>
                  <ion-input
                    *ngIf="!showPassword"
                    type="password"
                    name="password"
                    placeholder="Your password"
                    formControlName="password"
                    (focusout)="this.passwordSelected = true"
                    (ionFocus)="passwordFocus()"
                  ></ion-input>
                  <ion-input
                    *ngIf="showPassword"
                    type="text"
                    name="password"
                    placeholder="Your password"
                    formControlName="password"
                    (focusout)="this.passwordSelected = true"
                    (ionFocus)="passwordFocus()"
                  ></ion-input>
                  <img
                    class="show-password-icon"
                    tappable
                    (click)="switchShowPassword()"
                    *ngIf="showPassword"
                    src="./assets/icon/eye-fill.svg"
                  />
                  <img
                    class="show-password-icon"
                    tappable
                    (click)="switchShowPassword()"
                    *ngIf="!showPassword"
                    src="./assets/icon/eye-slash-fill.svg"
                  />
                  <span
                    *ngIf="passwordSelected && this.registerInfoForm.get('password').hasError('required')"
                    class="error"
                    >Oops, password is required.</span
                  >
                  <span
                    *ngIf="passwordSelected && this.registerInfoForm.get('password').hasError('maxlength')"
                    class="error"
                    >An password cannot exceed 70 letters.</span
                  >
                </div>
              </div>
              <div *ngIf="showSalonProfile">
                <div class="logo-container">
                  <img src="./assets/images/login_logo_white.png" />
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Your Business Name*</ion-label>
                  </div>
                  <ion-input
                    type="text"
                    name="salonName"
                    placeholder="Your business name"
                    formControlName="salonName"
                    (focusout)="this.salonNameSelected = true"
                    (ionFocus)="businessNameFocus()"
                  ></ion-input>
                  <span
                    *ngIf="salonNameSelected && this.registerInfoForm.get('salonName').hasError('required')"
                    class="error"
                    >Oops, a business name is required.</span
                  >
                  <span
                    *ngIf="salonNameSelected && this.registerInfoForm.get('salonName').hasError('maxlength')"
                    class="error"
                    >A business name cannot exceed 100 letters.</span
                  >
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Your Country</ion-label>
                  </div>
                  <ion-select
                    placeholder="Please select"
                    cancelText="Cancel"
                    okText="OK"
                    formControlName="country"
                  >
                    <ion-select-option
                      *ngFor="let country of countries"
                      [value]="country.getID()"
                    >
                      {{country.getCountryName()}}
                    </ion-select-option>
                  </ion-select>
                </div>
                <div class="input-group">
                  <div class="label-container">
                    <ion-label class="white">Your Time Zone</ion-label>
                  </div>
                  <ion-select
                    placeholder="Please select"
                    cancelText="Cancel"
                    okText="OK"
                    formControlName="timeZone"
                  >
                    <ion-select-option
                      *ngFor="let timezone of timeZones"
                      [value]="timezone.value"
                    >
                      {{ timezone.text }}
                    </ion-select-option>
                  </ion-select>
                </div>
                <div class="notes-container">
                  <span class="notes">
                    By continuing, you agree to our
                    <b tappable (click)="onTermsOfService()"
                      >Terms of Services</b
                    >
                    and
                    <b tappable (click)="onPrivacyPolicy()">Privacy Policy</b>
                  </span>
                </div>
                <ion-button
                  [disabled]="!this.registerInfoForm.valid"
                  type="submit"
                  expand="block"
                  color="light"
                  tappable
                >
                  Sign Up
                </ion-button>
              </div>

              <div
                *ngIf="!showSalonProfile"
                tappable
                class="next-container"
                (click)="salonProfile()"
              >
                <ion-button
                  [disabled]="!registerInfoForm.controls.firstName.valid ||
                !registerInfoForm.controls.email.valid ||
                !registerInfoForm.controls.phoneNumber.valid ||
                !registerInfoForm.controls.password.valid 
                "
                  color="light"
                >
                  Next →
                </ion-button>
              </div>
            </form>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
